import React, {
  useState,
  useEffect,
  Fragment,
  useCallback,
  useMemo,
} from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Types } from 'mongoose';

import { VariableActions } from '../../../store/actions/variables';

import Select from '../../Select';

import iconAdd from '../../../assets/images/icon_add-form.svg';
import iconDelete from '../../../assets/images/icon_delete-form.svg';
import iconEdit from '../../../assets/images/edit-form.svg';
import reordenarCima from '../../../assets/images/reordenar_cima.svg';
import MenuVariaveis from '../../MenuVariaveis';

import {
  ValidationType,
  ValidationTypeIcon,
  ValidationTypeName,
} from '../../../util/validation-type';

const getIcon = (validationName) => {
  const defaultIconIndex = 0;
  const name = ValidationTypeIcon[validationName || defaultIconIndex];
  const Icon = require(`../../../assets/images/validacao_${name}_dark.svg`);
  return Icon;
};

const SelectValidation = ({ value, onChange }) => {
  const [isOpen, setIsOpen] = useState(null);

  const handleChange = (_value) => {
    onChange({ target: { name: 'validationType', value: _value } });
  };

  return (
    <div className="form-group validation-input-group mb-1">
      <label>Validação</label>
      <input
        type="text"
        disabled
        className="form-control outline-none input-control mt-1"
        value={ValidationTypeName[value]}
      />
      <img className="validation-input-icon" src={getIcon(value)} alt="" />
      <i className="arrow down" />
      <button
        // disabled={props.item && props.item.type === 'Menu'}
        onClick={() => setIsOpen(!isOpen)}
        type="button"
      />

      {/* VALIDAÇÃO DROPDOWN */}
      <div
        className="validation-dropdown"
        hidden={!isOpen}
        onClick={() => setIsOpen(false)}
      >
        {/* VALIDAÇÃO DROPDOWN LINE */}
        <div
          className="validation-dropdown-line"
          onClick={() => handleChange(ValidationType.Email)}
        >
          <span className="image email" />
          <span>Email</span>
          <i className="arrow down" hidden={value !== ValidationType.Email} />
        </div>

        {/* VALIDAÇÃO DROPDOWN LINE */}
        <div
          className="validation-dropdown-line"
          onClick={() => handleChange(ValidationType.CPF)}
        >
          <span className="image cpf" />
          <span>CPF</span>
          <i className="arrow down" hidden={value !== ValidationType.CPF} />
        </div>

        {/* VALIDAÇÃO DROPDOWN LINE */}
        <div
          className="validation-dropdown-line"
          onClick={() => handleChange(ValidationType.CNPJ)}
        >
          <span className="image cnpj" />
          <span>CNPJ</span>
          <i className="arrow down" hidden={value !== ValidationType.CNPJ} />
        </div>

        {/* VALIDAÇÃO DROPDOWN LINE */}
        <div
          className="validation-dropdown-line"
          onClick={() => handleChange(ValidationType.Date)}
        >
          <span className="image data" />
          <span>Data (dd/mm/aaaa)</span>
          <i className="arrow down" hidden={value !== ValidationType.Date} />
        </div>

        {/* VALIDAÇÃO DROPDOWN LINE */}
        <div
          className="validation-dropdown-line"
          onClick={() => handleChange(ValidationType.Cellphone)}
        >
          <span className="image celular" />
          <span>Telefone</span>
          <i
            className="arrow down"
            hidden={value !== ValidationType.Cellphone}
          />
        </div>

        {/* VALIDAÇÃO DROPDOWN LINE */}
        <div
          className="validation-dropdown-line"
          onClick={() => handleChange(ValidationType.Url)}
        >
          <span className="image url" />
          <span>Url</span>
          <i className="arrow down" hidden={value !== ValidationType.Url} />
        </div>

        {/* VALIDAÇÃO DROPDOWN LINE */}
        <div
          className="validation-dropdown-line"
          onClick={() => handleChange(ValidationType.Number)}
        >
          <span className="image numero" />
          <span>Número</span>
          <i className="arrow down" hidden={value !== ValidationType.Number} />
        </div>

        {/* VALIDAÇÃO DROPDOWN LINE */}
        <div
          className="validation-dropdown-line"
          onClick={() => handleChange(ValidationType.RegularExpression)}
        >
          <span className="image expressao" />
          <span>Expressão Regular</span>
          <i
            className="arrow down"
            hidden={value !== ValidationType.RegularExpression}
          />
        </div>
      </div>
    </div>
  );
};

const Question = ({
  index,
  question,
  totalQuestions,
  handleUpdate,
  handleRemove,
  handleUpPosition,
  handleDownPosition,
  variableOptions,
  handleAddVariable,
}) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [isEditingTitle, setIsEditingTitle] = useState(false);
  const [questionData, setQuestionData] = useState({
    _id: '',
    title: '',
    question: '',
    errorMessage: '',
    errorMessageFinal: '',
    hasValidation: false,
    maxTries: '',
    validation: '',
    validationType: 1,
    variable: '',
  });

  useEffect(() => {
    if (question) {
      setQuestionData(question);
    }
  }, [question]);

  const handleInputChange = (event) => {
    const { name, value, checked, type } = event.target;
    const newValue = type === 'checkbox' ? checked : value;

    const updatedQuestion = { ...questionData, [name]: newValue };
    setQuestionData(updatedQuestion);
    handleUpdate(updatedQuestion);
  };

  const selectedVariableOption = useMemo(() => {
    const { variable } = questionData;
    return { label: variable, value: variable };
  }, [questionData?.variable]);

  const handleCreateVariable = (variable) => {
    handleAddVariable(variable);
    handleInputChange({
      target: { name: 'variable', value: variable },
    });
  };

  return (
    <div className="container-info-perguntas">
      <div className="container-perguntas">
        <div className="main-question-container">
          <div className="reorder-container">
            <button
              disabled={index === 0}
              onClick={handleUpPosition}
              type="button"
            >
              <img
                className={index === 0 ? 'disabled' : ''}
                src={reordenarCima}
                alt="arrow-up"
              />
            </button>
            <button
              className="question-down"
              disabled={index === totalQuestions}
              onClick={handleDownPosition}
              type="button"
            >
              <img
                className={index === totalQuestions ? 'disabled' : ''}
                src={reordenarCima}
                alt="arrow-down"
              />
            </button>
          </div>
          <div className="title-container-question">
            {isEditingTitle ? (
              <input
                name="title"
                onChange={handleInputChange}
                value={questionData.title}
              />
            ) : (
              <p style={{ width: 90 }}>{questionData.title}</p>
            )}
            <img
              alt=""
              className="pointer"
              src={iconEdit}
              onClick={() => setIsEditingTitle(!isEditingTitle)}
            />
            <img
              alt=""
              className="pointer"
              src={iconDelete}
              onClick={handleRemove}
            />
          </div>
        </div>
        <img
          alt=""
          src="/assets/images/icons/seta_close.svg"
          onClick={() => setIsExpanded(!isExpanded)}
          className={isExpanded ? 'pointer' : 'isRotateIcon pointer'}
        />
      </div>

      <div className="container-question-form" hidden={!isExpanded}>
        <div>
          <MenuVariaveis
            onSelect={(variavel) =>
              handleInputChange({
                target: {
                  value: `${questionData.question} {${variavel}}`,
                  name: 'question',
                },
              })
            }
            buttonRight="27px"
            buttonBottom="25px"
            id={`form-${questionData._id}-question`}
            isTooltip
            hidden={false}
          >
            <div className="form-group error-message-input-group mb-2">
              <label>Pergunta</label>
              <div>
                <textarea
                  type="text"
                  name="question"
                  value={questionData.question}
                  onChange={handleInputChange}
                  placeholder="Digite aqui sua pergunta"
                />
              </div>
            </div>
          </MenuVariaveis>
          <div className="form-group mb-1">
            <label>Salvar resposta para variável</label>
            <Select
              options={variableOptions}
              value={selectedVariableOption}
              onChange={(option) =>
                option &&
                handleInputChange({
                  target: {
                    name: 'variable',
                    value: option.value,
                  },
                })
              }
              onCreateOption={handleCreateVariable}
              isCreatable
            />
          </div>

          <div className="form-group validation-input-group mb-1">
            <div className="form-group row mb-1">
              <div className="custom-control custom-switch mt-2">
                <input
                  type="checkbox"
                  className="custom-control-input"
                  name="hasValidation"
                  id={`has-validation-${questionData._id}`}
                  checked={questionData.hasValidation}
                  onChange={handleInputChange}
                />
                <label
                  className="custom-control-label"
                  htmlFor={`has-validation-${questionData._id}`}
                >
                  Validação
                </label>
              </div>
            </div>

            <div hidden={!questionData.hasValidation}>
              <SelectValidation
                value={questionData.validationType}
                onChange={handleInputChange}
              />

              <div
                className="form-group validation-input-group-expression mb-1"
                hidden={!(questionData.validationType === 6)}
              >
                <label>Padrão da Expressão</label>
                <input
                  type="text"
                  placeholder="ex: [A-Z,a-z,0-9]"
                  name="validation"
                  value={questionData.validation}
                  onChange={handleInputChange}
                  className="form-control outline-none input-control mt-1"
                />
              </div>

              <div className="form-group error-message-input-group mb-2">
                <label>Mensagem de erro de validação</label>
                <div>
                  <textarea
                    name="errorMessage"
                    value={questionData.errorMessage}
                    onChange={handleInputChange}
                  />
                </div>
              </div>

              <div className="form-group tries-amount mb-0">
                <span>Quantidade máx. de tentativas&nbsp;</span>
                <input
                  type="number"
                  name="maxTries"
                  value={questionData.maxTries || ''}
                  onChange={handleInputChange}
                />
              </div>

              <div className="form-group error-message-input-group mb-1">
                <label>Mensagem de finalização</label>
                <div className="error-message-input-group-2-textarea">
                  <textarea
                    name="errorMessageFinal"
                    value={questionData.errorMessageFinal}
                    onChange={handleInputChange}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default (props) => {
  const { item, match, doUpdateItem } = props;
  const { botid: botId } = match.params;
  const { questions } = item;

  const { variables } = useSelector((state) => state.variables.variablesState);

  const dispatch = useDispatch();

  const variableOptions = useMemo(() => {
    return variables && variables.bot
      ? variables.bot.map((_variable) => ({
          value: _variable.name,
          label: _variable.name,
        }))
      : [];
  }, [variables]);

  const handleAddQuestion = () => {
    const hasQuestion = !!questions?.length;
    const title = hasQuestion ? questions.length + 1 : 1;

    const newQuestion = {
      title: `Pergunta ${title} `,
      question: '',
      variable: '',
      validationType: 1,
      hasValidation: false,
      validation: '',
      errorMessage: '',
      maxTries: '',
      errorMessageFinal: '',
      _id: Types.ObjectId().toString(),
    };

    const updatedQuestions = hasQuestion
      ? [...questions, newQuestion]
      : [newQuestion];

    doUpdateItem({ questions: updatedQuestions });
  };

  const handleRemove = useCallback(
    (removeIndex) => {
      const updatedQuestions = questions.filter(
        (_, index) => index !== removeIndex
      );

      doUpdateItem({ questions: updatedQuestions });
    },
    [questions, doUpdateItem]
  );

  const handleUpdate = useCallback(
    (index, updatedQuestion) => {
      const updatedQuestions = questions;
      updatedQuestions[index] = updatedQuestion;

      doUpdateItem({ questions: updatedQuestions });
    },
    [questions, doUpdateItem]
  );

  const handleUpPosition = useCallback(
    (index) => {
      questions.splice(index - 1, 0, questions.splice(index, 1)[0]);
      doUpdateItem({ question: questions });
    },
    [questions, doUpdateItem]
  );

  const handleDownPosition = useCallback(
    (index) => {
      questions.splice(index + 1, 0, questions.splice(index, 1)[0]);
      doUpdateItem({ question: questions });
    },
    [questions, doUpdateItem]
  );

  const handleCreateVariable = useCallback((variable) => {
    const payload = {
      botId,
      type: 'user',
      active: true,
      name: variable,
      value: '',
    };

    dispatch(VariableActions.create(payload));
  }, []);

  return (
    <Fragment>
      <div>
        {!!questions?.length &&
          questions.map((question, index) => (
            <Question
              question={question}
              key={question._id}
              index={index}
              totalQuestions={item.questions.length - 1}
              handleUpPosition={() => handleUpPosition(index)}
              handleDownPosition={() => handleDownPosition(index)}
              handleUpdate={(updatedQuestion) =>
                handleUpdate(index, updatedQuestion)
              }
              handleRemove={() => handleRemove(index)}
              variableOptions={variableOptions}
              handleAddVariable={(variable) => handleCreateVariable(variable)}
            />
          ))}
      </div>

      <div className="container-add-pergunta">
        <p className="handler-title">Adicionar Pergunta</p>
        <img
          alt=""
          className="pointer"
          src={iconAdd}
          onClick={handleAddQuestion}
        />
      </div>
    </Fragment>
  );
};
